import { createComponent } from "react-fela";
import { useRouter } from "next/router";
import get from "lodash.get";

import SummaryPost from "~/components/resource/summary/post";

export default ({ resources, hasSidebar }) => {
    const { query } = useRouter();
    const page = parseInt(get(query, "page", 1));

    return (
        <ResourceListing hasSidebar={hasSidebar}>
            {resources &&
                resources.length &&
                resources.map((resource, index) => {
                    return (
                        <SummaryPost
                            resource={resource}
                            key={index}
                            isFeature={index == 0 && page == 1}
                        />
                    );
                })}
        </ResourceListing>
    );
};

const ResourceListing = createComponent(({ hasSidebar }) => ({
    extend: [
        {
            condition: hasSidebar,
            style: {
                flexBasis: "75%"
            }
        }
    ]
}));
